import { useEffect, useRef, useState } from 'react';
import './home.css';
import Sidebar from '../sidebar/sidebar';
import { Carousel } from 'antd';
import image from "../../assets/Large-screens/1.png"
import image1 from "../../assets/updated-small-screen-images/1.png"
import image2 from "../../assets/updated-small-screen-images/2.png"
import image3 from "../../assets/updated-small-screen-images/3.png"
import image4 from "../../assets/updated-small-screen-images/4.png"
import image5 from "../../assets/updated-small-screen-images/5.png"
import image6 from "../../assets/updated-small-screen-images/6.png"
import image7 from "../../assets/updated-small-screen-images/7.png"
import image8 from "../../assets/updated-small-screen-images/8.png"
import image9 from "../../assets/updated-small-screen-images/9.png"
import image10 from "../../assets/updated-small-screen-images/10.png"
import image11 from "../../assets/updated-small-screen-images/11.png"
import image12 from "../../assets/updated-small-screen-images/12.png"
import image13 from "../../assets/updated-small-screen-images/13.png"









// const contentStyle = {
//   margin: 0,
//   height: '160px',
//   color: '#fff',
//   lineHeight: '160px',
//   textAlign: 'center',
//   background: '#364d79',
// };

const Home = () => {
  const sectionsRef = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);  // To track the current section index

  // Function to handle the scrolling effect
  const handleScroll = () => {
    const sections = sectionsRef.current;
    const scrollPosition = window.scrollY; // Get current scroll position
    const windowHeight = window.innerHeight;

    // Calculate the index based on the scroll position and section height
    const index = Math.floor(scrollPosition / windowHeight);

    // Update the current index
    if (index !== currentIndex) {
      setCurrentIndex(index);
    }
  };

  // Add scroll event listener on mount and clean up on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentIndex]);

  return (
    <>
      <div className="home-container">
        <Sidebar />
        <div className="home-content">
          <img
            src={image}
            alt="example"
            className="home-image"
          />
        </div>
      </div>

      <div className="mobile-view">
      <Carousel arrows dotPosition="left" infinite={false}>
      <div>
      <img
            src={image1}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={image2}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
           src={image3}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={image4}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={image5}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={image6}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={image7}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
           src={image8}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
           src={image9}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
           src={image10}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={image11}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
           src={image12}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
           src={image13}
            alt="example"
            className="home-image"
          />
      </div>
    </Carousel>
      </div>
    </>
  );
};

export default Home;
